import { Slider } from '@progress/kendo-react-inputs';
import SettingsSubSection from '../../../../../components/common/SettingsSubSection';
import { useViewSliderValue } from '../../hooks/view-forms';

export function FixesSettings() {
    const fontSize = useViewSliderValue((x) => x.staticData.fixes.settings.fontSize);
    return (
        <div className="px-3 py-2" style={{ minWidth: '300px' }}>
            <SettingsSubSection title="Fix details">
                <div>
                    <div>Font size: {fontSize.value}</div>
                    <Slider
                        min={4}
                        max={20}
                        step={1}
                        largeStep={1}
                        className="w-100"
                        value={fontSize.value}
                        onChange={(e) => fontSize.onChange?.({ ...e, value: Math.round(e.value) })}
                    />
                </div>
            </SettingsSubSection>
        </div>
    );
}
